export default __webpack_public_path__ + "static/baptisteV2-320d16cb9120baea8706b89f54b62b90.png";